export const isFullyRestricted = (
	permissions: { [key: string]: boolean } | undefined,
	permissionKeys?: string[],
) => {
	if (!permissionKeys || permissionKeys.length === 0) return false;
	return permissionKeys.every((key) => permissions?.[key] === false);
};

export const isMenuEntirelyHidden = (
	permissions: { [key: string]: boolean } | undefined,
	menu: { [key: string]: { permissionKeys?: string[] } },
) => Object.values(menu).every((item) => isFullyRestricted(permissions, item.permissionKeys));
